import * as React from "react";
import getConfig from "next/config";
import NextRouter, { useRouter } from "next/router";
import { useBloomreachSiteLogos, CmsHeadTags, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { WishlistButton } from "@grandvisionhq/fun-wishlist/button";
import { ProductBlockSlotsProvider } from "@grandvisionhq/lib-visuals";
import { AlgoliaConfigProvider, SearchPage } from "@grandvisionhq/search";
import { useIntl } from "@grandvisionhq/state";
import { g as getAlgoliaConfig } from "../algolia.js";
import "@grandvisionhq/utils";
import { g as getServerUrl } from "../get-server-url.js";
const { publicRuntimeConfig } = getConfig();
const selfUrl = publicRuntimeConfig?.selfUrl || "";
const Page = ({ algoliaConfig, queryParams = {} }) => {
  const { getLabel } = useIntl();
  const siteLogos = useBloomreachSiteLogos();
  const router = useRouter();
  const url = `${selfUrl}${router.asPath}`;
  const pageTitle = queryParams.q ? `${getLabel("search.results.title")} '${queryParams.q}'` : getLabel("search.pageTitle");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, { title: pageTitle, ogUrl: url, noIndex: true, noFollow: true }), /* @__PURE__ */ React.createElement(AlgoliaConfigProvider, { ...algoliaConfig, router: NextRouter }, /* @__PURE__ */ React.createElement(
    ProductBlockSlotsProvider,
    {
      slots: {
        WishlistButton
      }
    },
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }),
    /* @__PURE__ */ React.createElement(
      SearchPage,
      {
        pageTitle,
        reimbursableLogos: {
          default: siteLogos.reimbursable,
          alternative: siteLogos.reimbursableAlternative
        },
        algoliaConfig: publicRuntimeConfig.algolia,
        queryParams
      }
    ),
    /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" })
  )));
};
Page.getInitialProps = async ({ req, query, locale, asPath = "", featureToggles }) => {
  const relatedIndexes = publicRuntimeConfig.algolia.indexes.filter(
    (index) => index.targetPath && asPath.includes(index.targetPath) || index.type === "content"
  );
  const {
    featureConfigs: { priceSegmentQueryKey = "", bloomreachRefPrefix },
    isMultilingualEnabled
  } = featureToggles;
  const priceSegmentCookie = req?.cookies[priceSegmentQueryKey];
  const serverUrl = getServerUrl(req);
  const algoliaConfig = await getAlgoliaConfig({
    clientQueryString: asPath,
    locale,
    indexes: relatedIndexes,
    ruleContexts: ["search"],
    isMultilingualEnabled,
    serverUrl,
    router: NextRouter,
    refPrefix: bloomreachRefPrefix
  });
  return { queryParams: query, algoliaConfig: { ...algoliaConfig, priceSegmentCookie } };
};
export {
  Page
};
//# sourceMappingURL=search.js.map
